import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from '@fluentui/react/lib/Icon';

import * as styles from './styles.scss';

export default observer(function CalendarSearchIcon({ isSmall }: { isSmall?: boolean }) {
    return (
        <div
            className={
                isSmall ? styles.calendarSearchSmallIconWrapper : styles.calendarSearchIconWrapper
            }>
            <Icon
                className={isSmall ? styles.calendarSearchSmallIcon : styles.calendarSearchIcon}
                iconName={ControlIcons.Calendar}
            />
        </div>
    );
});
